import { RouteObject } from 'react-router-dom';

import { Authorize } from '@/components';
import { BUSINESS_ROLE_GROUPS } from '@/components/security/AppRoles';
import { ErrorPage } from '@/pages/Layout/pages';

import TransitControl from '../TransitControl';

const TransitControlRoutes: RouteObject[] = [
  {
    path: 'transit-control',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.operations}
        fallback={<ErrorPage code={403} />}
      >
        <TransitControl />
      </Authorize>
    ),
  },
];

export default TransitControlRoutes;
